import dayjs from 'dayjs';

export default {
  install(Vue) {
    Vue.filter('dateFormatter', function(date) {
      return date
        ? dayjs(date).toString()
          ? dayjs(date)
              .toString()
              .substring(4, 16)
          : ''
        : '-';
    });

    Vue.filter('timestampFormatter', function(date) {
      if (!date || !dayjs(date) || !dayjs(date).toString()) return '-';

      return dayjs(date).format('DD-MM-YYYY HH:mm Z');
    });
  }
};
